module.exports = __webpack_public_path__ + "img/mybenefitsdepo.6c649a66.png";